(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire602b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire602b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6H2Fe", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("fWDOt")).then(function() {
    return parcelRequire('7TE64');
});

});
parcelRegister("34sDy", function(module, exports) {
"use strict";

var $eZGXe = parcelRequire("eZGXe");
module.exports = $eZGXe(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("eZGXe", function(module, exports) {
"use strict";
var $aea8150f0ad1d89a$var$cachedBundles = {};
var $aea8150f0ad1d89a$var$cachedPreloads = {};
var $aea8150f0ad1d89a$var$cachedPrefetches = {};
function $aea8150f0ad1d89a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $aea8150f0ad1d89a$var$cachedPreloads;
        case 'prefetch':
            return $aea8150f0ad1d89a$var$cachedPrefetches;
        default:
            return $aea8150f0ad1d89a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $aea8150f0ad1d89a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("k10ef", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("6DCs1")).then(function() {
    return parcelRequire('eKAjN');
});

});

var $b067c8feafa98a07$exports = {};
$parcel$extendImportMap({
    "fWDOt": "accordion.0a5c0e2a.js",
    "6DCs1": "banner.263783b8.js"
});

// Import CSS.

/* IMPORTS GO HERE */ function $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $792ccec6b5d943e1$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $95b490098770cbcb$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $7fdabead8cf98896$var$extendStatics = function extendStatics1(d, b) {
    $7fdabead8cf98896$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7fdabead8cf98896$var$extendStatics(d, b);
};
function $7fdabead8cf98896$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7fdabead8cf98896$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7fdabead8cf98896$export$18ce0697a983be9b = function __assign1() {
    $7fdabead8cf98896$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fdabead8cf98896$export$18ce0697a983be9b.apply(this, arguments);
};
function $7fdabead8cf98896$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7fdabead8cf98896$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7fdabead8cf98896$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7fdabead8cf98896$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7fdabead8cf98896$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7fdabead8cf98896$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $7fdabead8cf98896$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7fdabead8cf98896$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7fdabead8cf98896$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7fdabead8cf98896$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7fdabead8cf98896$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7fdabead8cf98896$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7fdabead8cf98896$export$45d3717a4c69092e(o, m, p);
}
function $7fdabead8cf98896$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7fdabead8cf98896$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7fdabead8cf98896$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7fdabead8cf98896$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7fdabead8cf98896$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7fdabead8cf98896$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7fdabead8cf98896$export$10c90e4f7922046c(v) {
    return this instanceof $7fdabead8cf98896$export$10c90e4f7922046c ? (this.v = v, this) : new $7fdabead8cf98896$export$10c90e4f7922046c(v);
}
function $7fdabead8cf98896$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7fdabead8cf98896$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7fdabead8cf98896$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7fdabead8cf98896$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7fdabead8cf98896$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7fdabead8cf98896$export$19a8beecd37a4c45 === "function" ? $7fdabead8cf98896$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7fdabead8cf98896$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7fdabead8cf98896$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $7fdabead8cf98896$var$ownKeys = function ownKeys1(o) {
    $7fdabead8cf98896$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $7fdabead8cf98896$var$ownKeys(o);
};
function $7fdabead8cf98896$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $7fdabead8cf98896$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $7fdabead8cf98896$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $7fdabead8cf98896$var$__setModuleDefault(result, mod);
    return result;
}
function $7fdabead8cf98896$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7fdabead8cf98896$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7fdabead8cf98896$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7fdabead8cf98896$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7fdabead8cf98896$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $95b490098770cbcb$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7fdabead8cf98896$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7fdabead8cf98896$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7fdabead8cf98896$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $7fdabead8cf98896$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $7fdabead8cf98896$export$2e2bcd8739ae039 = {
    __extends: $7fdabead8cf98896$export$a8ba968b8961cb8a,
    __assign: $7fdabead8cf98896$export$18ce0697a983be9b,
    __rest: $7fdabead8cf98896$export$3c9a16f847548506,
    __decorate: $7fdabead8cf98896$export$29e00dfd3077644b,
    __param: $7fdabead8cf98896$export$d5ad3fd78186038f,
    __esDecorate: $7fdabead8cf98896$export$3a84e1ae4e97e9b0,
    __runInitializers: $7fdabead8cf98896$export$d831c04e792af3d,
    __propKey: $7fdabead8cf98896$export$6a2a36740a146cb8,
    __setFunctionName: $7fdabead8cf98896$export$d1a06452d3489bc7,
    __metadata: $7fdabead8cf98896$export$f1db080c865becb9,
    __awaiter: $7fdabead8cf98896$export$1050f835b63b671e,
    __generator: $7fdabead8cf98896$export$67ebef60e6f28a6,
    __createBinding: $7fdabead8cf98896$export$45d3717a4c69092e,
    __exportStar: $7fdabead8cf98896$export$f33643c0debef087,
    __values: $7fdabead8cf98896$export$19a8beecd37a4c45,
    __read: $7fdabead8cf98896$export$8d051b38c9118094,
    __spread: $7fdabead8cf98896$export$afc72e2116322959,
    __spreadArrays: $7fdabead8cf98896$export$6388937ca91ccae8,
    __spreadArray: $7fdabead8cf98896$export$1216008129fb82ed,
    __await: $7fdabead8cf98896$export$10c90e4f7922046c,
    __asyncGenerator: $7fdabead8cf98896$export$e427f37a30a4de9b,
    __asyncDelegator: $7fdabead8cf98896$export$bbd80228419bb833,
    __asyncValues: $7fdabead8cf98896$export$e3b29a3d6162315f,
    __makeTemplateObject: $7fdabead8cf98896$export$4fb47efe1390b86f,
    __importStar: $7fdabead8cf98896$export$c21735bcef00d192,
    __importDefault: $7fdabead8cf98896$export$da59b14a69baef04,
    __classPrivateFieldGet: $7fdabead8cf98896$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7fdabead8cf98896$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7fdabead8cf98896$export$81fdc39f203e4e04,
    __addDisposableResource: $7fdabead8cf98896$export$88ac25d8e944e405,
    __disposeResources: $7fdabead8cf98896$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $7fdabead8cf98896$export$889dfb5d17574b0b
};


/* Accessible menu functions for Desktop */ var $acc41bba40053e86$export$2e2bcd8739ae039 = function() {
    var toggleSubnav = // Function to toggle the visibility of a submenu
    function toggleSubnav(li) {
        var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        // Determine whether to open or close the submenu
        var shouldBeOpen = isOpen !== null ? isOpen : !li.classList.contains('open');
        // Toggle the open class and aria-expanded attribute
        li.classList.toggle('open', shouldBeOpen);
        var btn = li.querySelector('button');
        btn.classList.toggle("open");
        // Add context to screen reader text label.
        var activatingA = li.querySelector("a");
        btn.setAttribute('aria-expanded', shouldBeOpen);
        // Update the screen reader text based on submenu state
        var screenReaderText = btn.querySelector('.screen-reader-text');
        if (!screenReaderText) return;
        screenReaderText.textContent = "".concat(shouldBeOpen ? 'Close' : 'Open', " submenu for \u201C").concat(activatingA.textContent);
    };
    var closeAllSubmenus = // Function to close all open submenus
    function closeAllSubmenus() {
        document.querySelectorAll('.menu-item-has-children.open').forEach(function(li) {
            return toggleSubnav(li, false);
        });
    };
    var setSubmenuLabel = // Function to set the label on submenus with children
    function setSubmenuLabel(submenu) {
        var activatingBtn = submenu.querySelector("button");
        /* Sets submenu button label, inserts it into a sr-only span in the btn. */ var buttonLabel = "Open submenu for \u201C".concat(activatingBtn.textContent, "\u201D");
        var btn = submenu.getElementsByTagName('button');
        // Create span element
        var span = document.createElement('span');
        span.classList.add('sr-only', 'screen-reader-text');
        span.textContent = buttonLabel;
        // Insert span into button
        if (btn[0]) btn[0].appendChild(span);
    };
    // Selecting the main wrapper of the accessible menus
    var menuWrappers = document.querySelectorAll('.accessible-menu');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Loop through each menu wrapper to add event listeners and submenu labels
        for(var _iterator = menuWrappers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var menuWrapper = _step.value;
            // Event for handling clicks on submenu buttons
            menuWrapper.addEventListener('click', function(event) {
                var button = event.target.closest('.menu-item-has-children > button');
                if (button) {
                    event.stopPropagation();
                    var li = button.closest('.menu-item-has-children');
                    toggleSubnav(li);
                }
            });
            // Handling focus change to close submenus when focus moves out of them
            menuWrapper.addEventListener('focusin', function(event) {
                if (!event.target.closest('.menu-item-has-children.open')) closeAllSubmenus();
            });
            /**
	     * Close when user clicks outside of the submenu.
	     *
	     * @param {object} links - Submenus.
	     */ document.addEventListener("click", function(event) {
                if (!event.target.classList.contains("menu-main--submenu")) closeAllSubmenus();
            });
            // Adding keyboard navigation support (Escape key to close submenus)
            menuWrapper.addEventListener('keydown', function(event) {
                if (event.key === 'Escape') closeAllSubmenus();
            });
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                // Set label on submenus with children
                for(var _iterator1 = menuWrapper.querySelectorAll('.menu-item-has-children')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var submenu = _step1.value;
                    setSubmenuLabel(submenu);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};


var $6e56bd20d27e88a6$export$2e2bcd8739ae039 = function() {
    // Selecting elements for mobile menu functionality
    var mobileMenu = document.getElementById('nav-main--mobile--wrapper');
    if (!mobileMenu) return;
    var btnCloseMenu = document.getElementById('btn-menu-mobile--close');
    var btnOpenMenu = document.getElementById('btn-menu-mobile--open');
    // Function to toggle the mobile navigation menu
    var toggleMobileMenu = function(isOpen) {
        // Toggle the open class and set focus to the appropriate button
        mobileMenu.classList.toggle('open', isOpen);
        (isOpen ? mobileMenu : btnOpenMenu).focus();
    };
    // Event listeners for opening and closing the mobile menu
    btnOpenMenu.addEventListener('click', function() {
        return toggleMobileMenu(true);
    });
    btnCloseMenu.addEventListener('click', function() {
        return toggleMobileMenu(false);
    });
    // Close mobile menu with Escape key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && mobileMenu.classList.contains('open')) toggleMobileMenu(false);
    });
};


/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */ function $12cb7db7b90bab2b$export$2e2bcd8739ae039() {
    var isIe = /(trident|msie)/i.test(navigator.userAgent);
    if (isIe && document.getElementById && window.addEventListener) window.addEventListener("hashchange", function() {
        var id = location.hash.substring(1);
        if (!/^[A-z0-9_-]+$/.test(id)) return;
        var element = document.getElementById(id);
        if (!element) return;
        if (!/^(?:a|select|input|buttonextarea)$/i.test(element.tagName)) element.tabIndex = -1;
        element.focus();
    }, false);
}




function $604fb00e16720e43$var$init() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $792ccec6b5d943e1$export$71511d61b312f219)(function() {
        var accordionsList, accordionsJS, videoElement, videoJS;
        return (0, $7fdabead8cf98896$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    /* Load JS for blocks only if they exist on the page */ /* https://parceljs.org/features/code-splitting/ */ /* Accordion */ accordionsList = document.querySelector(".accordion");
                    if (!accordionsList) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (parcelRequire("6H2Fe"))
                    ];
                case 1:
                    accordionsJS = _state.sent();
                    accordionsJS.render();
                    _state.label = 2;
                case 2:
                    /* Video Element */ videoElement = document.querySelector(".video-container");
                    if (!videoElement) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (parcelRequire("k10ef"))
                    ];
                case 3:
                    videoJS = _state.sent();
                    videoJS.render();
                    _state.label = 4;
                case 4:
                    /* Global Components */ (0, $12cb7db7b90bab2b$export$2e2bcd8739ae039)();
                    (0, $acc41bba40053e86$export$2e2bcd8739ae039)();
                    (0, $6e56bd20d27e88a6$export$2e2bcd8739ae039)();
                    return [
                        2
                    ];
            }
        });
    })();
}
/* Initialize Site Scripts */ $604fb00e16720e43$var$init();



})();
//# sourceMappingURL=motif.js.map
